var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3861 1.21187C11.7472 0.931005 12.2528 0.931005 12.6139 1.21187L21.6139 8.21187C21.8575 8.40132 22 8.69263 22 9.00122V20.0012C22 20.7969 21.6839 21.5599 21.1213 22.1225C20.5587 22.6852 19.7957 23.0012 19 23.0012H5C4.20435 23.0012 3.44129 22.6852 2.87868 22.1225C2.31607 21.5599 2 20.7969 2 20.0012V9.00122C2 8.69263 2.14247 8.40132 2.38606 8.21187L11.3861 1.21187ZM4 9.4903V20.0012C4 20.2664 4.10536 20.5208 4.29289 20.7083C4.48043 20.8959 4.73478 21.0012 5 21.0012H19C19.2652 21.0012 19.5196 20.8959 19.7071 20.7083C19.8946 20.5208 20 20.2664 20 20.0012V9.4903L12 3.26808L4 9.4903Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.0012C8 11.4489 8.44772 11.0012 9 11.0012H15C15.5523 11.0012 16 11.4489 16 12.0012V22.0012C16 22.5535 15.5523 23.0012 15 23.0012C14.4477 23.0012 14 22.5535 14 22.0012V13.0012H10V22.0012C10 22.5535 9.55228 23.0012 9 23.0012C8.44772 23.0012 8 22.5535 8 22.0012V12.0012Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon5);
export default __webpack_public_path__ + "static/media/link-icon-5.aa0737028698e1a6f5e457938e045e76.svg";
export { ForwardRef as ReactComponent };